import React from 'react';

import ZoomControl from './ZoomControl';
import { Props as MapProps } from '../index';

import { useStyles } from './styles';
import { useControlsStyles } from '../hooks';

export const Controls = ({ showZoomControl, controlComponents }: Props) => {
  const controlsStyles = useControlsStyles();
  const classes = useStyles({ controlsStyles });

  const mapControls = <ZoomControl showZoomControl={showZoomControl} />;

  return (
    <div className={classes.container}>
      {controlComponents ? controlComponents({ mapControls }) : mapControls}
    </div>
  );
};

export interface Props extends Pick<MapProps, 'showZoomControl' | 'controlComponents'> { }

